import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import { useAppDispatch } from "../../../../../hooks/useTypedSelector";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import useCrudTable from "../../../../../hooks/useCrudTable";
import { ShelvingUnitTableColumns } from "../../domain/columns/shelvingUnitTableColumns";
import { shelvingUnitSchema } from "../../domain/schemas/shelvingUnitSchema";
import useCrudFilters from "../../../../../hooks/useCrudFilters";
import { useTranslation } from "react-i18next";
import { ShelvingUnitTableFilters } from "../features/shelvingUnitTableFilters";

export const ShelvingUnitPage = () => {
  const { t } = useTranslation("common");

  const dispatch = useAppDispatch();

  const title = t("Shelving units");

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootShelvingUnit",
      fields: {},
    },
    "shelvingUnitFilter",
  );

  const crud = useCrudTable({
    prefix: "shelvingUnits",
    entity: "ShelvingUnit",
    columns: ShelvingUnitTableColumns,
    schema: shelvingUnitSchema,
    filters: crudFilters.filters,
    addAction: "/shelvingUnits/add",
    columnAction: "/shelvingUnits/edit/:id",
  });

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>
          <LayoutHeaderActions>{crud.addButton}</LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className="mb-3" />
          <ShelvingUnitTableFilters {...crudFilters} />
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
